import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	Menu,
	MenuItem,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography
} from '@mui/material'
import { useApp } from 'core/contexts/profile.context'
import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { Cancel, Dots, Edit, Settings, View } from '../../core/icons'
import { deleteTourniquet, getTourniquets } from '../../services/tourniquet/tourniquet.service'
import { parseLockers } from '../Lockers/parse'

export const TourniquetsPage = () => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const { profile } = useApp()
	const navigate = useNavigate()
	const [currentId, setCurrentId] = useState<any>()
	const [openDeleteModal, setOpenDeleteModal] = React.useState(false)
	const [reasonText, setReasonText] = React.useState('')

	const { data: tourniquets, refetch } = useQuery(['getTourniquets'], {
		queryFn: () => getTourniquets()
	})

	const handleDeleteOpenModal = () => setOpenDeleteModal(true)
	const handleDeleteCloseModal = () => setOpenDeleteModal(false)
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setCurrentId(event.currentTarget.id)
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	const deleteTourniquetMutate = useMutation({
		mutationFn: ({ tourniquet_id, reason }: any) => deleteTourniquet({ tourniquet_id, reason }),
		onSuccess: () => {
			toast.success('Successfully deleted')
			setOpenDeleteModal(false)
			setAnchorEl(null)
			setReasonText('')
			refetch()
		}
	})
	const handleEditTourniquet = () => {
		navigate(`/tourniquets/${currentId}?edit`)
	}
	const handleViewTourniquet = () => {
		navigate(`/tourniquets/${currentId}?view`)
	}

	const onChangeReason = (e: any) => {
		setReasonText(e.target.value)
	}

	const handleTourniquetDelete = () => {
		if (reasonText) {
			deleteTourniquetMutate.mutate({
				tourniquet_id: currentId,
				reason: reasonText
			})
		} else {
			toast.error('Нужнa причина!')
		}
	}

	return (
		<div>
			<Box display='flex' justifyContent='space-between' p={2}>
				<Typography variant='title_2'>Турникеты</Typography>
				{profile?.user?.role.permissions.includes('update_tourniquet') && (
					<Button onClick={() => navigate('/tourniquets/add')} variant='contained'>
						Добавить
					</Button>
				)}
			</Box>
			<Divider />
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 650 }} aria-label='simple table'>
					<TableHead>
						<TableRow>
							<TableCell>№</TableCell>
							<TableCell align='left'>ID</TableCell>
							<TableCell align='left'>Наименование</TableCell>
							<TableCell align='left'>Статус</TableCell>
							<TableCell align='left'>ID замка</TableCell>
							<TableCell align='right'>
								<Settings />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{tourniquets?.data &&
							parseLockers(tourniquets.data).map((row: any) => (
								<TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component='th' scope='row'>
										{row.id}
									</TableCell>
									<TableCell align='left'>{row.external_id}</TableCell>
									<TableCell align='left'>{row.name}</TableCell>
									<TableCell align='left'>{row.status}</TableCell>
									<TableCell align='left'>{row.external_id}</TableCell>
									<TableCell align='right'>
										<Button
											id={row.id}
											aria-controls={open ? 'basic-menu' : undefined}
											aria-haspopup='true'
											aria-expanded={open ? 'true' : undefined}
											onClick={handleClick}
										>
											<Dots />
										</Button>
										<Menu
											id={`basic-menu-${row.id}`}
											anchorEl={anchorEl}
											open={open}
											onClose={handleClose}
											MenuListProps={{
												'aria-labelledby': 'basic-button'
											}}
										>
											<MenuItem onClick={handleViewTourniquet} key={`menu-item-${row.id}`}>
												<View
													style={{
														color: '#349EFF',
														marginRight: '8px'
													}}
												/>
												Просмотр карточки турникета
											</MenuItem>
											{profile?.user?.role.permissions.includes('update_tourniquet') && (
												<MenuItem onClick={handleEditTourniquet} key={`menu-item-${row.id}`}>
													<Edit
														style={{
															marginRight: '8px'
														}}
													/>
													Редактировать
												</MenuItem>
											)}
											{profile?.user?.role.permissions.includes('update_tourniquet') && (
												<MenuItem onClick={handleDeleteOpenModal}>
													<Cancel
														style={{
															marginRight: '8px'
														}}
													/>
													Удалить
												</MenuItem>
											)}
										</Menu>
									</TableCell>
									<Dialog
										open={openDeleteModal}
										onClose={handleClose}
										aria-labelledby='alert-dialog-title'
										aria-describedby='alert-dialog-description'
									>
										<DialogTitle id='alert-dialog-title'>Вы уверены?</DialogTitle>
										<DialogContent>
											<DialogContentText id='alert-dialog-description'>
												Прежде чем удалить, убедитесь в том что данные удалятся безвозвратно и
												без сохранении
											</DialogContentText>
											<Box mt={2}>
												<TextField
													label='Причина удаления'
													placeholder=''
													fullWidth
													multiline
													rows={3}
													type='text'
													value={reasonText}
													onChange={onChangeReason}
													name='reason'
												/>
											</Box>
										</DialogContent>
										<DialogActions
											sx={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'end'
											}}
										>
											<Button
												onClick={handleDeleteCloseModal}
												variant='text'
												color='success'
												style={{ marginBottom: '16px' }}
											>
												Нет, оставить
											</Button>
											<Button
												onClick={handleTourniquetDelete}
												autoFocus
												variant='text'
												disabled={!reasonText}
												color='error'
											>
												Да, удалить
											</Button>
										</DialogActions>
									</Dialog>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	)
}
